module.exports = __webpack_public_path__ + "static/media/fig_18.238b920c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_18.jpg
// module id = 648
// module chunks = 0